<template>
  <li class="sidebar-search-wrapper" style="visibility: hidden">
    <!-- BEGIN RESPONSIVE QUICK SEARCH FORM -->
    <!-- DOC: Apply "sidebar-search-bordered" class the below search form to have bordered search box -->
    <!-- DOC: Apply "sidebar-search-bordered sidebar-search-solid" class the below search form to have bordered & solid search box -->
    <form class="sidebar-search  " action="page_general_search_3.html" method="POST">
      <a href="javascript:;" class="remove">
        <i class="icon-close"></i>
      </a>
      <div class="input-group">
        <input type="text" class="form-control" placeholder="Search...">
        <span class="input-group-btn">
          <a href="javascript:;" class="btn submit">
            <i class="icon-magnifier"></i>
          </a>
        </span>
      </div>
    </form>
    <!-- END RESPONSIVE QUICK SEARCH FORM -->
  </li>
</template>

<script>
  export default {}
</script>



// WEBPACK FOOTER //
// src/app/components/sidebar/SidebarSearch.vue